import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import AuthService from "../../services/auth-service";
import {
  FORGOT_PASSWORD,
  INITIAL_CHANGE_PASSWORD,
  LOGIN,
  LOGOUT,
  RESEND_OTP,
  RESET_PASSWORD,
  VERIFY_EMAIL,
  VERIFY_OTP,
  VERIFY_RESET_TOKEN,
  VERIFY_USER,
} from "../actions";
import {
  getCurrentUser,
  getPermission,
} from "../shared/action";
import {
  CHECK_MY_DETAILS,
  forgotPasswordError,
  forgotPasswordSuccess,
  GET_ANNOTATION_URL,
  getAnnotationUrlSuccess,
  initialChangePasswordError,
  initialChangePasswordSuccess,
  loginError,
  loginSuccess,
  logoutError,
  logoutSuccess,
  resendOtpError,
  resendOtpSuccess,
  resetPasswordError,
  resetPasswordSuccess,
  verifyEmailError,
  verifyEmailSuccess,
  verifyOtpError,
  verifyOtpSuccess,
  verifyResetTokenError,
  verifyResetTokenSuccess,
  verifyUserError,
  verifyUserSuccess
} from "./action";

import { toast } from "react-toastify";
import ToastElement from "../../components/toast";
import { restrictSubmenu } from "../../helpers/restrictSubmenu";
import { parseMessage } from "../../helpers/util";

export function* watchVerifyUser() {
  yield takeEvery(VERIFY_USER, verifyUser);
}

const verifyUserAsync = async (token) => {
  return AuthService.verifyUser(token);
};

function* verifyUser({ payload }) {
  try {
    const response = yield call(verifyUserAsync, payload.token);
    if (response.data.success) {
      yield put(
        verifyUserSuccess(response.data.success, response.data.message)
      );
      payload.history.push({
        pathname: "/auth/login",
        state: { responseMsg: response.data.message },
      });
    } else {
      payload.history.push({
        pathname: "/auth/login",
        state: { responseMsg: response.data.message },
      });
      yield put(verifyUserError(response.data.message));
    }
  } catch (error) {
    payload.history.push({
      pathname: "/auth/login",
      state: {
        responseMsg: parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        ),
      },
    });
    yield put(
      verifyUserError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchLogin() {
  yield takeEvery(LOGIN, login);
}

const loginAsync = async (data) => {
  return AuthService.login(data);
};

function* login({ payload }) {
  try {
    const response = yield call(loginAsync, payload.loginData);
    if (response.data.success) {
      yield put(loginSuccess(response.data.success, response.data.message));
      if (payload.loginData.remember === 1) {
        localStorage.setItem("email", payload.loginData.email);
        localStorage.setItem("password", payload.loginData.password);
        localStorage.setItem("remember", payload.loginData.remember);
      } else {
        localStorage.removeItem("email");
        localStorage.removeItem("password");
        localStorage.removeItem("remember");
      }
      if (response.data.data.isFirstTimeLogin) {
        payload.history.push({
          pathname: "/auth/initial-change-password",
          state: { userId: response.data.data.userId, email: response.data.data.email },
        });
      } else {
        payload.history.push({
          pathname: "/auth/otp",
          state: { loginData: payload.loginData },
        });
      }
    } else {
      yield put(loginError(response.data.message));
    }
  } catch (error) {
    yield put(
      loginError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = async (data) => {
  return AuthService.forgotPassword(data);
};

function* forgotPassword({ payload }) {
  try {
    const response = yield call(
      forgotPasswordAsync,
      payload.forgotPasswordData
    );
    if (response.data.success) {
      yield put(
        forgotPasswordSuccess(response.data.success, response.data.message)
      );
    } else {
      yield put(forgotPasswordError(response.data.message));
    }
  } catch (error) {
    yield put(
      forgotPasswordError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchVerifyResetToken() {
  yield takeEvery(VERIFY_RESET_TOKEN, verifyResetToken);
}

const verifyResetTokenAsync = async (token) => {
  return AuthService.verifyResetToken(token);
};

function* verifyResetToken({ payload }) {
  try {
    const response = yield call(verifyResetTokenAsync, payload.token);
    if (response.data.success) {
      yield put(
        verifyResetTokenSuccess(response.data.success, response.data.message)
      );
    } else {
      payload.history.push({
        pathname: "/auth/login",
        state: { responseMsg: response.data.message },
      });
      yield put(verifyResetTokenError(response.data.message));
    }
  } catch (error) {
    payload.history.push({
      pathname: "/auth/login",
      state: {
        responseMsg: parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        ),
      },
    });
    yield put(
      verifyResetTokenError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = async (data) => {
  return AuthService.resetPassword(data);
};

function* resetPassword({ payload }) {
  try {
    const response = yield call(resetPasswordAsync, payload.resetPasswordData);
    if (response.data.success) {
      yield put(
        resetPasswordSuccess(response.data.success, response.data.message)
      );
      payload.history.push({
        pathname: "/auth/login",
        state: { responseMsg: response.data.message },
      });
    } else {
      yield put(resetPasswordError(response.data.message));
    }
  } catch (error) {
    yield put(
      resetPasswordError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchInitialChangePassword() {
  yield takeEvery(INITIAL_CHANGE_PASSWORD, initialChangePassword);
}

const initialChangePasswordAsync = async (data) => {
  return AuthService.initialChangePassword(data);
};

function* initialChangePassword({ payload }) {
  try {
    const response = yield call(
      initialChangePasswordAsync,
      payload.initialChangePasswordData
    );
    if (response.data.success) {
      localStorage.setItem("currentUser", JSON.stringify(response.data.data));
      localStorage.setItem("token", response.data.data.token);
      yield put(initialChangePasswordSuccess(response.data.data));
      // Fetch permission/user
      yield put(getPermission(restrictSubmenu));
      yield put(getCurrentUser());
      // yield put(getNotificationList());
      payload.history.push("/");
    } else {
      yield put(initialChangePasswordError(response.data.message));
    }
  } catch (error) {
    yield put(
      initialChangePasswordError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchVerifyOtp() {
  yield takeEvery(VERIFY_OTP, verifyOtp);
}

const verifyOtpAsync = async (data) => {
  return AuthService.verifyOtp(data);
};

function* verifyOtp({ payload }) {
  try {
    const response = yield call(verifyOtpAsync, payload.otpData);
    if (response.data.success) {
      localStorage.setItem("currentUser", JSON.stringify(response.data.data));
      localStorage.setItem("token", response.data.data.token);
      yield put(verifyOtpSuccess(response.data.data));
      // Fetch permission/user
      yield put(getPermission(restrictSubmenu));
      yield put(getCurrentUser());
      // yield put(getNotificationList());
      payload.history.push("/");
    } else {
      yield put(verifyOtpError(response.data.message));
    }
  } catch (error) {
    yield put(
      verifyOtpError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchResendOtp() {
  yield takeEvery(RESEND_OTP, resendOtp);
}

const resendOtpAsync = async (data) => {
  return AuthService.resendOtp(data);
};

function* resendOtp({ payload }) {
  try {
    const response = yield call(resendOtpAsync, payload.loginData);
    if (response.data.success) {
      yield put(resendOtpSuccess(response.data.success, response.data.message));
    } else {
      yield put(resendOtpError(response.data.message));
    }
  } catch (error) {
    yield put(
      resendOtpError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchVerifyEmail() {
  yield takeEvery(VERIFY_EMAIL, verifyEmail);
}

const verifyEmailAsync = async (token) => {
  return AuthService.verifyEmail(token);
};

function* verifyEmail({ payload }) {
  try {
    const response = yield call(verifyEmailAsync, payload.token);
    if (response.data.success) {
      yield put(
        verifyEmailSuccess(response.data.success, response.data.message)
      );
      payload.history.push({
        pathname: "/auth/login",
        state: { responseMsg: response.data.message },
      });
    } else {
      payload.history.push({
        pathname: "/auth/login",
        state: { responseMsg: response.data.message },
      });
      yield put(verifyEmailError(response.data.message));
    }
  } catch (error) {
    payload.history.push({
      pathname: "/auth/login",
      state: {
        responseMsg: parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        ),
      },
    });
    yield put(
      verifyEmailError(
        parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )
      )
    );
  }
}

export function* watchLogout() {
  yield takeEvery(LOGOUT, logout);
}

const logoutAsync = async () => {
  return AuthService.logout();
};

function* logout() {
  try {
    const response = yield call(logoutAsync);
    if (response.data.success) {
      localStorage.removeItem("token");
      localStorage.removeItem("currentUser");
      yield put(logoutSuccess(response.data.success, response.data.message));
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("currentUser");
      yield put(logoutError(response.data.message));
    }
  } catch (error) {
    localStorage.removeItem("token");
    localStorage.removeItem("currentUser");
    yield put(logoutError(error.response.data.message));
  }
}


export function* watchGetAnnotationUrl() {
  yield takeEvery(GET_ANNOTATION_URL, getAnnotationUrl);
}

const getAnnotationUrlAsync = async () => {
  return AuthService.getAnnotationUrl();
};

function* getAnnotationUrl() {
  try {
    const response = yield call(getAnnotationUrlAsync);
    if (response.data.success) {
      yield put(getAnnotationUrlSuccess(response?.data?.data?.url))
    } else {
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );

    }
  } catch (error) {
    toast.error(
      <ToastElement type="error" message={error.response.data.message} />,
      { containerId: "default", position: "bottom-right" }
    );

  }
}

// export function* getAnnotationUrl() {
//   return AuthService.getAnnotationUrl();
// }



export function* watchCheckMyDetails() {
  yield takeEvery(CHECK_MY_DETAILS, checkMyDetails);
}

const checkMyDetailsAsync = async (data) => {
  return AuthService.checkMyDetails(data);
};

function* checkMyDetails({ payload }) {
  try {
    const response = yield call(checkMyDetailsAsync, payload.accessToken);
    if (response.data.success) {
      localStorage.setItem("currentUser", JSON.stringify(response.data.data?.user));
      localStorage.setItem("token", payload.accessToken);
      // yield put(checkMyDetailsSuccess(response.data.data));
      // Fetch permission/user
      yield put(verifyOtpSuccess(response.data.data?.user));
      yield put(getPermission(restrictSubmenu));
      yield put(getCurrentUser());
      // yield put(getNotificationList());

      setTimeout(() => {
        payload.history.push("/");
      }, 500);
    } else {
      // yield put(checkMyDetailsError(response.data.message));
      onCheckMyDetailsError(response.data.message, payload.history);
    }
  } catch (error) {
    // yield put(checkMyDetailsError(error.response.data.message));
    onCheckMyDetailsError(error, payload.history);
  }
}

const onCheckMyDetailsError = (error, history) => {
  localStorage.removeItem("token");
  localStorage.removeItem("currentUser");
  setTimeout(() => {
    history.push("/");
  }, 500);
  toast.error(
    <ToastElement type="error" message={error.response.data.message} />,
    { containerId: "default", position: "bottom-right" }
  );
}

export default function* rootSaga() {
  yield all([
    fork(watchVerifyUser),
    fork(watchLogin),
    fork(watchVerifyOtp),
    fork(watchResendOtp),
    fork(watchInitialChangePassword),
    fork(watchForgotPassword),
    fork(watchVerifyResetToken),
    fork(watchResetPassword),
    fork(watchVerifyEmail),
    fork(watchLogout),
    fork(watchGetAnnotationUrl),
    fork(watchCheckMyDetails),
  ]);
}
